import { render } from "./LoginForm.vue?vue&type=template&id=995f6af8"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=995f6af8&lang=css"

import exportComponent from "E:\\OpenServer\\domains\\vue\\vue-catalog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__